import { render } from "./LabdaqPendingResults.vue?vue&type=template&id=7714c52c"
import script from "./LabdaqPendingResults.vue?vue&type=script&lang=js"
export * from "./LabdaqPendingResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/LabdaqPendingResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7714c52c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7714c52c', __exports__)) {
    console.log('reload')
    api.reload('7714c52c', __exports__)
  }
  
  module.hot.accept("./LabdaqPendingResults.vue?vue&type=template&id=7714c52c", () => {
    console.log('re-render')
    api.rerender('7714c52c', render)
  })

}


export default __exports__